module.exports = __webpack_public_path__ + "static/media/telegram(2).696a972f.svg";